import { SET_MESSAGE } from "../actions/messageActions";

export const setMessage = (data) => ({
	type: SET_MESSAGE,
	payload: data
});